const resizeImage = (image: Blob) => {
    return new Promise((resolve: (resized: Blob) => void) => {
        const blobURL = window.URL.createObjectURL(image);
        const img = new Image();
        img.src = blobURL;
    
        img.onload = function () {
            let sizeCase;
            let ratio;
            if(img.width >= img.height) {
                sizeCase = 1;
                ratio = img.width / img.height;
            } else {
                sizeCase = 2;
                ratio = img.height / img.width;
            }
            const resized = [];
            switch(sizeCase) {
                case 1:
                    resized.push(50 * ratio, 50);
                    break;
                case 2:
                    resized.push(50, 50 * ratio);
                    break;
            }

            window.URL.revokeObjectURL(blobURL);
            const canvas = document.createElement('canvas');
            canvas.width = 50;
            canvas.height = 50;
            const ctx = canvas.getContext('2d');
            ctx!.drawImage(img, 0, 0, resized[0], resized[1]);
            canvas.toBlob(function (blob) {
                resolve(blob!);
            }, 'image/jpeg', 1);
        };
    })
}

export default resizeImage;